import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

export default function AIWebsiteBuilder() {
  return (
    <>
      <Navbar />

      <section className="py-24 bg-white">
        <div className="max-w-5xl mx-auto px-6">

           <Link
            to="/"
            className="text-blue-600 underline mb-6 inline-block"
          >
            ← Back to Home
          </Link>
          
          <h1 className="text-4xl font-bold mb-6">
            AI Website Builder for Local Businesses
          </h1>

          <p className="text-gray-600 mb-8">
            AI Growth Lab helps local businesses launch powerful AI-powered
            websites that generate leads, automate bookings, and improve
            customer engagement.
          </p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">
            Why AI Websites?
          </h2>

          <p className="text-gray-600 mb-6">
            Traditional websites require constant updates and manual work.
            AI-powered websites automate content generation, lead capture,
            and customer communication so businesses can grow faster.
          </p>

          <h2 className="text-2xl font-semibold mt-10 mb-4">
            Features
          </h2>

          <ul className="list-disc pl-6 text-gray-600">
            <li>AI generated website structure</li>
            <li>Automated lead capture</li>
            <li>Online booking integration</li>
            <li>AI chat automation</li>
            <li>SEO optimized pages</li>
          </ul>

        </div>
      </section>

      <Footer />
    </>
  );
}
